import { PropsWithChildren } from "react";
import { useAuth } from "../../hooks/useAuth";
import { UserRole } from "../../utils/types";

/** Shared with views that must disable trial-only features without rendering children. */
export function isTrialAccount(
  roles: UserRole[] | UserRole | null | undefined,
): boolean {
  if (roles == null) return false;
  return Array.isArray(roles)
    ? roles.some((role) => role === "TRIAL")
    : roles === "TRIAL";
}

export const NonTrialScope = ({ children }: PropsWithChildren) => {
  const { roles } = useAuth();

  if (isTrialAccount(roles)) {
    return null;
  }

  return <>{children}</>;
};
